import type { I18nT } from '@runtime/core/i18n/i18n'
import { Button } from '@runtime/components/ui/Button'
import styles from '@runtime/features/poster/components/PosterPrivateAccess.module.scss'

type PosterPrivateAccessProps = {
  t: I18nT
  isPrivateUnlocked: boolean
  onOpenPrivatePrompt: () => void
}

export default function PosterPrivateAccess({
  t,
  isPrivateUnlocked,
  onOpenPrivatePrompt,
}: PosterPrivateAccessProps) {
  return (
    <section className={styles.privateAccess}>
      {isPrivateUnlocked ? (
        <div className={styles.privateUnlocked}>
          {t('posterModal.privateUnlocked')}
        </div>
      ) : (
        <>
          <div className={styles.privateHint}>
            {t('posterModal.privateHint')}
          </div>
          <Button
            size="s"
            variant="ghost"
            className={styles.privateButton}
            onClick={onOpenPrivatePrompt}
          >
            {t('posterModal.privateButton')}
          </Button>
        </>
      )}
    </section>
  )
}
